import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  WithoutCollidingProps,
} from '../../theming';

export interface BaseSvgProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

type NonCollidingSVGProps = WithoutCollidingProps<BaseSvgProps, 'svg'>;
type NonCollidingSVGKeys = keyof NonCollidingSVGProps;

export const Svg = styled<'svg', NonCollidingSVGKeys>('svg', {
  shouldForwardProp: (prop): prop is NonCollidingSVGKeys =>
    shouldForwardProp(prop as NonCollidingSVGKeys),
})<BaseSvgProps>(
  defineWithTheme('svgs'),
  compose(
    background,
    border,
    color,
    display,
    layout,
    position,
    shadow,
    space,
    typography
  )
);

export type SvgProps = React.ComponentPropsWithRef<typeof Svg>;
